import React from 'react';
import _ from 'lodash';
import { Card } from '../../../components';

const CardTrade = ({ title, data }) => (
  <Card className="dashboard-card dashboard-card--trade">
    <h2>{title}</h2>
    {data.map(obj => {
      const classNames = [
        'dashboard-card-item',
        obj.extra ? 'dashboard-card-item--extra' : '',
        obj.featured ? 'dashboard-card-item--bold' : ''
      ].join(' ');
      return (
        <div key={_.uniqueId()} className={classNames}>
          <div className="description">{obj.label}</div>
          <div className="count">{obj.total}</div>
        </div>
      );
    })}
  </Card>
);

export default CardTrade;



// WEBPACK FOOTER //
// ./src/screens/admin/Dashboard/card-trade.js